import { LanguageSwitcher } from '@app/components/header/LanguageSwitcher';
import { getCompanyName, getDarkLogoImage, getIsLoggedIn } from '@app/ducks';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import cx from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import styles from './LayoutContent.module.scss';

interface Props {
  title: string;
  text?: string;
}

export const LayoutContent = ({ children, title, text }: React.WithChildren<Props>) => {
  const isUserLoggedIn = useSelector(getIsLoggedIn);
  const logoImageUrl = useSelector(getDarkLogoImage);
  const companyName = useSelector(getCompanyName);

  return (
    <div className={cx(styles.wrapper, 'bg-neutral-96')}>
      <div className="mb-10 flex items-center justify-between">
        {!isEmpty(logoImageUrl) ?
          <img src={logoImageUrl} className="h-auto max-h-16 w-auto max-w-48" alt={companyName} />
        : companyName}
        {!isUserLoggedIn && <LanguageSwitcher className={styles.switcher} />}
      </div>
      <div className="mb-4 overflow-hidden break-words">
        <h2 className="mb-4 heading-1">{title}</h2>
        {isDefined(text) && <p className="text-neutral-40 body-2">{text}</p>}
      </div>
      {children}
    </div>
  );
};
